import { IconsProps } from '@/types/shared'
import React from 'react'

const FeatureComingSoonIcons: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                viewBox="0 0 120 120"
                fill="none"
                className="w-full h-full drop-shadow-lg"
            >
                <path
                    d="M60 10L70 40L100 40L78 58L88 88L60 70L32 88L42 58L20 40L50 40Z"
                    fill="#FFD700"
                    opacity="0.9"
                />
                <circle cx="60" cy="60" r="25" fill="#FFA500" opacity="0.7" />
                <g fill="#FFD700">
                    <circle cx="30" cy="25" r="2" opacity="0.8">
                        <animate
                            attributeName="opacity"
                            values="0.8;0.3;0.8"
                            dur="2s"
                            repeatCount="indefinite"
                        />
                    </circle>
                    <circle cx="90" cy="35" r="1.5" opacity="0.6">
                        <animate
                            attributeName="opacity"
                            values="0.6;0.2;0.6"
                            dur="1.5s"
                            repeatCount="indefinite"
                        />
                    </circle>
                    <circle cx="25" cy="85" r="2.5" opacity="0.7">
                        <animate
                            attributeName="opacity"
                            values="0.7;0.2;0.7"
                            dur="1.8s"
                            repeatCount="indefinite"
                        />
                    </circle>
                </g>
            </svg>
        </div>
    )
}

export default FeatureComingSoonIcons
